import { Card, CardContent, CardHeader } from '@/modules/players/v3/components/shared/card/card';
import { GearCardSkeleton } from '@/modules/players/v3/components/shared/gear-card/gear-card-skeleton';

const GEAR_CELL_IDS = Array.from({ length: 4 }, () => crypto.randomUUID());
const DEAL_CELL_IDS = Array.from({ length: 12 }, () => crypto.randomUUID());

const DealCardSkeleton = () => (
  <div className='flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800'>
    <div className='aspect-square w-full animate-pulse border-b border-gray-200 bg-gray-100 dark:border-gray-700 dark:bg-gray-700' />
    <div className='flex flex-col gap-4 px-3 pb-2 pt-4'>
      <div className='space-y-1'>
        <div className='h-4 w-full animate-pulse rounded bg-gray-200 dark:bg-gray-700' />
        <div className='h-4 w-3/4 animate-pulse rounded bg-gray-200 dark:bg-gray-700' />
      </div>
      <div className='flex items-end gap-2'>
        <div className='flex flex-1 flex-col gap-1'>
          <div className='h-3 w-12 animate-pulse rounded bg-gray-200 dark:bg-gray-700' />
          <div className='h-4 w-16 animate-pulse rounded bg-gray-200 dark:bg-gray-700' />
        </div>
        <div className='h-9 flex-1 animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700' />
      </div>
    </div>
  </div>
);

export const MyGearSkeleton = () => {
  return (
    <Card className='transition-all duration-150'>
      <CardHeader>
        <div className='flex items-center gap-2'>
          <div className='h-6 w-24 animate-pulse rounded bg-gray-200 dark:bg-gray-700' />
          <div className='hidden h-5 w-40 animate-pulse rounded bg-gray-200 md:block dark:bg-gray-700' />
        </div>
        <div className='h-5 w-28 animate-pulse rounded bg-gray-200 dark:bg-gray-700' />
      </CardHeader>
      <CardContent className='flex flex-1 flex-col gap-16 bg-gray-50 pb-6 md:gap-14'>
        <div className='grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4'>
          {GEAR_CELL_IDS.map((id) => (
            <GearCardSkeleton key={id} fluid />
          ))}
        </div>
        <div className='flex flex-col gap-4'>
          <div className='h-6 w-56 animate-pulse rounded bg-gray-200 dark:bg-gray-700' />
          <div className='md:hidden'>
            <DealCardSkeleton />
          </div>
          <div className='hidden gap-4 md:grid md:grid-cols-3 lg:grid-cols-4'>
            {DEAL_CELL_IDS.map((id) => (
              <DealCardSkeleton key={id} />
            ))}
          </div>
          <div className='flex justify-center pt-6'>
            <div className='h-10 w-[140px] animate-pulse rounded-lg bg-gray-200 dark:bg-gray-700' />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
